export const CONTROLS_CONTAINER =
    " absolute top-0 right-0 left-0 bottom-0 flex flex-col my-auto justify-between cursor-pointer";
export const PLAY_BUTTON_CONTAINER =
    "flex-col items-center justify-center h-max w-max m-auto";
export const VIDEO_OVERLAY = "opacity-80";
export const VIDEO_CLASS = "w-max mx-auto h-auto";
export const MUTE_BUTTON_CONTAINER = "z-50 absolute h-max w-max self-center ";
export const VIDEO_CONTAINER = "relative  mx-auto";
